/**
 * Безопасная обёртка над localStorage с JSON-сериализацией.
 */

export const loadJSON = (key, fallback) => {
  try {
    const raw = localStorage.getItem(key);
    if (raw != null) {
      return JSON.parse(raw);
    }
  } catch (error) {
    console.warn(`Failed to load "${key}" from localStorage:`, error);
  }
  return fallback;
};

export const saveJSON = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.warn(`Failed to save "${key}" to localStorage:`, error);
  }
};

export const removeKeys = (...keys) => {
  keys.forEach((key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.warn(`Failed to remove "${key}" from localStorage:`, error);
    }
  });
};
